import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=05064ba5&scoped=true"
import script from "./loader.component.vue?vue&type=script&lang=js"
export * from "./loader.component.vue?vue&type=script&lang=js"
import style0 from "./loader.component.vue?vue&type=style&index=0&id=05064ba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05064ba5",
  null
  
)

export default component.exports